import Player from "@vimeo/player";

class HeroVideo {
    constructor(el) {
        this.videoElement = el.querySelector("iframe, video");
        this.isVimeo = this.videoElement.tagName.toLowerCase() === "iframe";
        this.isMobile = window.matchMedia("(max-width: 667px)").matches;

        // Buttons
        this.pauseBtn = document.getElementById("pause-btn");
        this.unMuteBtn = document.getElementById("unmute-btn");

        this.init();
    }

    init() {
        this.heroVideoContainer = document.querySelector("[data-vimeo-container]");
        this.featuredImage = document.querySelector("[data-hero-feature-image]");
        this.videoCoverImageMobile = document.querySelector("[data-display-mobile]");

        if (this.isVimeo) {
            this.videoPlayer = new Player(this.videoElement);
        } else {
            this.videoPlayer = this.videoElement; // Native <video> element
        }

        if (this.featuredImage && this.videoElement) {
            this.featuredImage.style.visibility = "hidden";
        }

        if (this.isMobile) {
            this.handleMobileView();
        }

        this.handlePlayPause();
        this.handleUnmuteMute();
    }

    handleMobileView() {
        if (this.heroVideoContainer) {
            this.heroVideoContainer.style.display = "none";
        }

        if (this.isVimeo) {
            this.videoPlayer.pause();
        } else {
            this.videoPlayer.pause();
        }

        this.togglePlayPauseIcons(false);

        if (this.videoCoverImageMobile) {
            this.videoCoverImageMobile.style.display = "";
            if (this.featuredImage) this.featuredImage.style.display = "none";
        } else {
            if (this.featuredImage) this.featuredImage.style.visibility = "";
        }
    }

    handlePlayPause() {
        if (!this.pauseBtn || !this.videoPlayer) return;

        this.pauseBtn.addEventListener("click", () => {
            if (this.isVimeo) {
                this.videoPlayer.getPaused().then((paused) => {
                    this.togglePlayState(paused);
                }).catch((error) => {
                    console.error("Error toggling play/pause", error);
                });
            } else {
                const isPaused = this.videoPlayer.paused;
                this.togglePlayState(isPaused);
            }
        });
    }

    togglePlayState(paused) {
        if (paused) {
            if (this.isVimeo) {
                this.videoPlayer.play();
            } else {
                this.videoPlayer.play();
            }
            this.togglePlayPauseIcons(true);
            if (this.isMobile && this.heroVideoContainer) {
                this.heroVideoContainer.style.display = "";
            }
        } else {
            if (this.isVimeo) {
                this.videoPlayer.pause();
            } else {
                this.videoPlayer.pause();
            }
            this.togglePlayPauseIcons(false);
        }
    }

    togglePlayPauseIcons(isPlaying) {
        const pauseIcon = document.getElementById("pause-icon");
        const playIcon = document.getElementById("play-icon");

        if (isPlaying) {
            playIcon.classList.remove("show");
            pauseIcon.classList.add("show");
        } else {
            playIcon.classList.add("show");
            pauseIcon.classList.remove("show");
        }
    }

    handleUnmuteMute() {
        if (!this.unMuteBtn || !this.videoPlayer) return;

        const unMuteIcon = document.getElementById("unmute-icon");
        const muteIcon = document.getElementById("mute-icon");

        this.unMuteBtn.addEventListener("click", () => {
            if (this.isVimeo) {
                this.videoPlayer.getMuted().then((muted) => {
                    this.toggleMuteState(muted, unMuteIcon, muteIcon);
                }).catch((error) => {
                    console.error("Error toggling mute/unmute", error);
                });
            } else {
                const muted = this.videoPlayer.muted;
                this.toggleMuteState(muted, unMuteIcon, muteIcon);
            }
        });
    }

    toggleMuteState(muted, unMuteIcon, muteIcon) {
        if (muted) {
            if (this.isVimeo) {
                this.videoPlayer.setMuted(false);
            } else {
                this.videoPlayer.muted = false;
            }
            unMuteIcon.style.display = "none";
            muteIcon.style.display = "";
        } else {
            if (this.isVimeo) {
                this.videoPlayer.setMuted(true);
            } else {
                this.videoPlayer.muted = true;
            }
            unMuteIcon.style.display = "";
            muteIcon.style.display = "none";
        }
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const videoContainers = document.querySelectorAll("#vimeo-player");

    videoContainers.forEach((container) => {
        if (container) {
            new HeroVideo(container);
        }
    });
});

export default HeroVideo;
